import { EmergencyAlarmActivationMethod } from 'features/emergency-alarm-settings/domain/models/emergency-alarm-activation-method';
import { EmergencyAlarmDeviceTriggerAction } from 'features/emergency-alarm-settings/domain/models/emergency-alarm-device-trigger-action';
import { EmergencyAlarmLocationType } from 'features/emergency-alarm-settings/domain/models/emergency-alarm-location-type';

export const preAlarmDurationOptions = [2, 4, 6, 8, 10];

export default interface EmergencyAlarmSetting {
  id: string;
  name?: string;
  organisationUnitId: string | null;
  emergencyAlarmEnabled: boolean;
  activationMethod: EmergencyAlarmActivationMethod;
  deviceTriggerAction: EmergencyAlarmDeviceTriggerAction;
  preAlarmEnabled: boolean;
  preAlarmDurationS: number;
  soundEnabled: boolean;
  locationType: EmergencyAlarmLocationType;
  isDefaultTemplateSetting: boolean;
}
